module.exports = __webpack_public_path__ + "static/media/test1_2.1c4fdc25.png";